
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.7 11.522l8.985 6.23c.368.261.593.336.84.128.226-.19.191-.586.126-.894l-.061-.242-.993-3.205h1.317c1.75 0 3.17 1.418 3.17 3.167v8.293c0 1.053.814 1.915 1.847 1.991l.158.006a2 2 0 001.996-2v-8.171a7.287 7.287 0 00-7.29-7.283H14.58l1.02-3.318.05-.21c.066-.308.101-.705-.125-.894-.222-.187-.427-.145-.733.055L5.7 11.522z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    